module.exports = __webpack_public_path__ + "static/media/ruta-1280.b6829ef8.webp";